// extracted by mini-css-extract-plugin
module.exports = {"parentModal":"style_parentModal__13Ica","agreementBlock":"style_agreementBlock__DvOxv"};